<!--

    Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<mat-accordion displayMode="flat" hideToggle>
  <mat-expansion-panel [expanded]="expanded" data-test-class="expansion-panel" #expansionPanel>
    <mat-expansion-panel-header tabIndex="-1">
      <mat-panel-title data-test-class="panel-title">
        <ods-button
          class="[&_button:focus-visible]:-outline-offset-2"
          variant="ghost"
          size="fit"
          [ariaExpanded]="expansionPanel.expanded"
          [ariaLabel]="'Bereich ' + (expansionPanel.expanded ? 'reduzieren' : 'erweitern')"
        >
          <ods-icon
            icon
            class="transition-transform duration-100 ease-in-out"
            [ngClass]="{ 'rotate-90': expansionPanel.expanded }"
            name="chevron-right"
            fill="text"
          />
        </ods-button>
        <h3>{{ headline }}</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <!-- expandable start -->
    <div
      [ngStyle]="{
        visibility: expansionPanel.expanded ? 'visible' : 'hidden',
        display: expansionPanel.expanded ? 'block' : 'none',
      }"
    >
      <ng-content />
    </div>
    <!-- expandable end -->
  </mat-expansion-panel>
</mat-accordion>
